import React, { useState, useEffect } from 'react';
import { Form, Input, Checkbox, Row, Col, Upload, Radio, Select, DatePicker, InputNumber, Popconfirm, message, Button } from 'antd';
import { UploadOutlined, RedoOutlined, DoubleLeftOutlined, DoubleRightOutlined, CaretRightFilled } from '@ant-design/icons';
import { returnTable } from '../../admins/doctorAdmin/masterManagement/templateMaster/functions'
import RenderResponseWithAns from '../renderResponseWithAnsConsent';
import { horiLayout, layout } from '../../commonImports/import1'
import radioActiveImg from '../../../assets/radio-active-new.png';
import radioInactiveImg from '../../../assets/radio-inactive-new.png';
import checkboxActiveImg from '../../../assets/checkbox-active-new.png';
import checkboxInactiveImg from '../../../assets/checkbox-inactive-new.png';

// Custom styled checkbox that uses the image assets but preserves the original Checkbox functionality
const StyledCheckbox = (props) => {
  // State to force updates when form values change
  const [, forceUpdate] = useState({});
  
  // Effect to listen for form value changes
  useEffect(() => {
    const intervalId = setInterval(() => {
      // This will force the component to re-check the form values
      forceUpdate({});
    }, 200);
    
    return () => clearInterval(intervalId);
  }, []);
  
  // Get the checked state from props or form values
  const isChecked = props.checked !== undefined ? 
                    props.checked : 
                    (props.value && props.form && Array.isArray(props.form.getFieldValue([props.name, 'answer'])) && 
                    props.form.getFieldValue([props.name, 'answer'])?.includes(props.value));
  
  return (
    <span className="custom-checkbox-wrapper" style={{ 
      position: 'relative', 
      display: 'inline-flex', 
      alignItems: 'center', 
      cursor: 'pointer',
      padding: '8px 0'
    }}>
      <Checkbox 
        {...props} 
        style={{ 
          opacity: 0, 
          position: 'absolute', 
          width: '100%', 
          height: '100%', 
          margin: 0, 
          zIndex: 1,
          cursor: 'pointer',
          left: 0,
          top: 0
        }}
      />
      <img 
        src={isChecked ? checkboxActiveImg : checkboxInactiveImg} 
        alt={isChecked ? "Checked" : "Unchecked"}
        style={{ width: '20px', height: '20px', marginRight: '8px', pointerEvents: 'none' }}
      />
      <span style={{ pointerEvents: 'none' }}>{props.children}</span>
    </span>
  );
};

// Custom styled radio that uses the image assets but preserves the original Radio functionality
const StyledRadio = (props) => {
  // State to force updates when form values change
  const [, forceUpdate] = useState({});
  
  // Effect to listen for form value changes
  useEffect(() => {
    const intervalId = setInterval(() => {
      // This will force the component to re-check the form values
      forceUpdate({});
    }, 200);
    
    return () => clearInterval(intervalId);
  }, []);
  
  // Get the checked state from props or determine it from the value and onChange
  const isChecked = props.checked !== undefined ? props.checked : false;
  
  return (
    <span className="custom-radio-wrapper" style={{ 
      position: 'relative', 
      display: 'inline-flex', 
      alignItems: 'center', 
      cursor: 'pointer',
      padding: '8px 0'
    }}>
      <Radio 
        {...props} 
        style={{ 
          opacity: 0, 
          position: 'absolute', 
          width: '100%', 
          height: '100%', 
          margin: 0, 
          zIndex: 1,
          cursor: 'pointer',
          left: 0,
          top: 0
        }}
      />
      <img 
        src={isChecked ? radioActiveImg : radioInactiveImg} 
        alt={isChecked ? "Selected" : "Unselected"}
        style={{ width: '20px', height: '20px', marginRight: '8px', pointerEvents: 'none' }}
      />
      <span style={{ pointerEvents: 'none' }}>{props.children}</span>
    </span>
  );
};

let demoField = [
  {
    type: 'multi',
    label: 'Response',
    name: 'response',
    required: true,
    showlabel: false,
    message: 'Please input response',
    prefix: '+91',
    initialValue: [null]
  },
]


const renderElement = (props, form, p, name, elemType, uploadList, custObj) => {
  let style = { width: '100%' }
  let a = <Input
    style={{ width: '100%' }}
    
    className={'bottom-border-cust'} />
  let elem = <Input style={style} placeholder={p.name} />;


  const uploadButtonPicture = (a) => (
    <Button disabled={a}>
      <UploadOutlined /> Upload
    </Button>
  )

  /// ------------------------ Select element type ---------------------- ///
  switch (elemType) {
    case 'CHECK_BOX':
      elem = (
        <Checkbox.Group style={{ width: '100%' }}
          onChange={(checkedValues) => {
            console.log(checkedValues, "checkbox");
            // Force parent component to update
            if (props.rerenderCustom) {
              props.rerenderCustom();
            }
          }}
        >
          <Row>
            {p.checkboxList.map((m) => {
              let flag = custObj && custObj.attachedQuestions ? custObj.attachedQuestions.find((a) => a.attachedVal == m.optionTitle) : undefined;
              
              // Get the current form values to determine if this checkbox is checked
              const currentValues = form.getFieldValue([name, 'answer']) || [];
              const isChecked = Array.isArray(currentValues) && currentValues.includes(m.optionTitle);
              
              return (
                <Col
                  span={custObj.attachedQuestions?.length > 0 ? 24 : 12}
                  key={m.optionTitle}
                >
                  <StyledCheckbox 
                    value={m.optionTitle} 
                    checked={isChecked}
                    form={form}
                    name={name}
                    onClick={() => {
                      // Handle manual click to update state immediately
                      const currentVals = form.getFieldValue([name, 'answer']) || [];
                      const newVals = isChecked 
                        ? currentVals.filter(v => v !== m.optionTitle)
                        : [...currentVals, m.optionTitle];
                        
                      form.setFieldsValue({
                        [name]: { answer: newVals }
                      });
                      
                      if (props.rerenderCustom) {
                        props.rerenderCustom();
                      }
                    }}
                  >
                    {m.optionTitle} {flag ? <CaretRightFilled /> : null}
                  </StyledCheckbox>
                  {flag && (
                    <Col
                      flex={2}
                      style={{ border: '1px solid #ccc', padding: '0px 10px' }}
                    >
                      {custObj.attachedQuestions.map((a) => {
                        if (a.attachedVal == m.optionTitle) {
                          return (
                            <RenderResponseWithAns
                              key={a.attachedVal}
                              rerenderCustom={() => {
                                if (props.rerenderCustom) {
                                  props.rerenderCustom();
                                }
                              }}
                              layout={layout}
                              record={a}
                              form={form}
                              chat={false}
                              attachedQuestions={[]}
                            />
                          )
                        }
                        return null;
                      })}
                    </Col>
                  )}
                </Col>
              )
            })}
          </Row>
        </Checkbox.Group>
      )
      break;

    case 'RADIO_BUTTON':
      const radioOptions = p.radioList || [];
      const includeNotApplicable = p.addNotApplicable === 'true';
      const uniqueOptions = new Set(radioOptions.map((option) => option.optionTitle));

      if (p.radioDisplayType === 'DROPDOWN') {
        elem = (
          <Select
            placeholder="Select Answer"
            allowClear
            style={{ width: '300px', color:'#00003B' }}
            onChange={(value) => {
              // Force parent component to update
              if (props.rerenderCustom) {
                props.rerenderCustom();
              }
            }}
          >
            {radioOptions.map((item) => (
              <Select.Option key={item.optionTitle} value={item.optionTitle} style={{ color:'#00003B' }}>
                {item.optionTitle}
              </Select.Option>
            ))}
            {includeNotApplicable && !uniqueOptions.has('Not Applicable') && (
              <Select.Option value={null} style={{ color:'#00003B' }}>Not Applicable</Select.Option>
            )}
          </Select>
        );
      } else {
        elem = (
          <Radio.Group
            className={props.chat ? 'chatresponse-wrapper' : ''}
            style={{ width: '100%', color:'#00003B' }}
            onChange={(e) => {
              console.log(e, "radio");
              // Force parent component to update
              if (props.rerenderCustom) {
                props.rerenderCustom();
              }
            }}
          >
            <Row>
              {radioOptions.map((m) => {
                let flag = custObj && custObj.attachedQuestions ? custObj.attachedQuestions.find((a) => a.attachedVal == m.optionTitle) : undefined;
                
                // Get the current form value to determine if this radio is checked
                const currentValue = form.getFieldValue([name, 'answer']);
                const isChecked = currentValue === m.optionTitle;
                
                return (
                  <Col span={12} key={m.optionTitle}>
                    <StyledRadio 
                      value={m.optionTitle} 
                      checked={isChecked}
                      onClick={() => {
                        // Handle manual click to update state immediately
                        form.setFieldsValue({
                          [name]: { answer: m.optionTitle }
                        });
                        
                        if (props.rerenderCustom) {
                          props.rerenderCustom();
                        }
                      }}
                      style={{ color:'#00003B' }}
                    >
                      {m.optionTitle} {flag ? <CaretRightFilled /> : null}
                    </StyledRadio>
                    {flag && (
                      <Col
                        flex={2}
                        style={{ border: '1px solid #ccc', padding: '0px 10px' }}
                      >
                        {custObj.attachedQuestions.map((a) => {
                          if (a.attachedVal == m.optionTitle) {
                            return (
                              <RenderResponseWithAns
                                key={a.attachedVal}
                                rerenderCustom={() => {
                                  if (props.rerenderCustom) {
                                    props.rerenderCustom();
                                  }
                                }}
                                record={a}
                                full
                                form={form}
                                chat={false}
                                attachedQuestions={[]}
                              />
                            );
                          }
                          return null;
                        })}
                      </Col>
                    )}
                  </Col>
                );
              })}
            </Row>
            {includeNotApplicable && !uniqueOptions.has('Not Applicable') && (
              <Row>
                <Col span={12}>
                  <StyledRadio 
                    value={null} 
                    checked={form.getFieldValue([name, 'answer']) === null}
                    onClick={() => {
                      // Handle manual click to update state immediately
                      form.setFieldsValue({
                        [name]: { answer: null }
                      });
                      
                      if (props.rerenderCustom) {
                        props.rerenderCustom();
                      }
                    }}
                    style={{ color:'#00003B' }}
                  >
                    Not Applicable
                  </StyledRadio>
                </Col>
              </Row>
            )}
          </Radio.Group>
        );
      }
      break;

    case "FREE_TEXT":
      p.freeText.textInputType == 'SINGLE_LINE' ?
        a = <Input 
        style={{ width: '100%', color:'#00003B' }}  
        className={'bottom-border-cust'} />
        :
        p.freeText.textInputType == 'MULTI_LINE' ?
          a = <Input.TextArea
          rows={2}
              style={{ width: '100%', color:'#00003B' }}
              className={'bottom-border-cust'} 
              />
          :
          a = <Input 
          style={{ width: '100%', color:'#00003B' }} 
          className={'bottom-border-cust'} 
          />
      elem = a;
    break;


    case "NUMBER":
      a = <InputNumber 
        style={{ width: '100%', color:'#00003B' }} 
        className={'bottom-border-cust'} 
      />
      elem = a;
      break;

    case "DATE":
      a = (<DatePicker style={{ width: '100%', color:'#00003B' }} />)
      elem = a;
      break;

    case "FILE":
      a = (
        <Upload
          name="avatar"
          listType="picture"
          className="avatar-uploader"
          action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
        >
          {uploadList.length > 0 ? uploadButtonPicture(true) : uploadButtonPicture(false)}
        </Upload>
      )
      elem = a;
      break;

    case "TABLE":
      elem = returnTable(p, props, { answers: custObj.answers })
      break;

    case "FILL_IN_BLANKS":
      const regex = /[_]+/g;
        // elem = <h1>{p.fillInBlanks.answerSummary.replaceAll(regex,'<h1>'+regex+'</h1>')}</h1>
        let arr = p.fillInBlanks.answerSummary.split(regex);
        let typeArray = p.fillInBlanks.blanksType ? p.fillInBlanks.blanksType : [];
        elem = (
          <Input.Group>
          <div style={{display: 'flex'}}>
            {arr.map((a,i)=>{
                 let type = typeArray[i];
                 let elem =   <Input style={{width:'auto',marginLeft:'5px', marginRight:'5px', border:'0px', borderBottom:'1px solid grey', background:'none'}}/>;
                 if(type && type.type == 'select' && type.values && type.values.length > 0){
                  elem = (
                    <Select placeholder={"Select Answer"} style={{width:'auto', minWidth:'100px',marginLeft:'5px', marginRight:'5px', color:'#00003B'}}>
                      {type.values.map((a)=>{
                        return(
                          <Select.Option value={a} key={a} style={{ color:'#00003B' }}>{a}</Select.Option>
                        )
                      })}
                    </Select>
                  )
                 }
              if(i != arr.length-1){
                return(
                  <>
                  <p>{a}</p>
                  <Form.Item
                  name={[p.slugValueNew, 'answer', i]}
                  noStyle
                  rules={[{ required: false, message: 'Province is required' }]}
                >
                      {elem}
                 </Form.Item>
                 </>
                )
              }else{
                return(
                <p>{a}</p>
                )
              }
            })}
          </div>
          </Input.Group>
        )
    break;
    default:
  }
  return elem
}

export default renderElement;